import { useEffect, useState } from "react";
import { Card, ProgressBar, useT } from "@mmm/ui";
export function ProcessingStatus({ title, message, completed, total }: { title: string; message: string; completed?: number; total?: number }) {
  const t = useT();
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    const start = Date.now();
    const timer = setInterval(() => setSeconds(Math.floor((Date.now() - start) / 1000)), 1000);
    return () => clearInterval(timer);
  }, []);
  return <Card padding="md" tone="purple" className="mmm-processing-status" aria-busy="true">
    <div role="status"><h3><span className="mmm-btn-busy-dot" aria-hidden="true" />{title}</h3><p>{message}</p></div>
    {total !== undefined && <ProgressBar value={completed ?? 0} max={total} />}
    <p className="mmm-processing-elapsed">{t("tests.elapsedSeconds", { seconds })}</p>
  </Card>;
}
